export default {
  header: {
    title: 'Use your points',
    balance: '{{value}} pts available',
  },
  option_label: '{{value}} pts',
  buttons: {
    none: 'None',
  },
  toasts: {
    enabled: 'Loyalty points applied successfully',
    removed: 'Loyalty points removed',
  },
};
